module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer008"
    }
  }, [_c('p', {
    staticClass: "_ded",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_vm._v("To Blue Moon Circle, past and present, and to my readers because y’all rock. Thanks for asking for this book.")]), _vm._v(" "), _c('div', {
    staticClass: "x15"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    staticClass: "i100",
    attrs: {
      "alt": "black cat",
      "src": "image/2.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-787d1afd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ded.vue
// module id = 66
// module chunks = 0